import { render, staticRenderFns } from "./DistanceViewer.vue?vue&type=template&id=b872e616"
import script from "./DistanceViewer.vue?vue&type=script&lang=ts"
export * from "./DistanceViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports